var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "drag-and-drop-endpoints",
    {
      attrs: {
        "js-plumb-instance": _vm.jsPlumbInstance,
        "reference-parameters": _vm.referenceParameters,
        "endpoint-parameters": _vm.endpoints
      },
      on: {
        "endpoints-updated": _vm.endpointsUpdated,
        "endpoint-created": _vm.endpointCreated,
        click: _vm.eventProxies.click,
        dblclick: _vm.eventProxies.dblclick,
        contextmenu: _vm.eventProxies.contextmenu,
        mouseover: _vm.eventProxies.mouseover,
        mouseout: _vm.onMouseOut,
        mousedown: _vm.eventProxies.mousedown,
        mouseup: _vm.eventProxies.mouseup,
        maxConnections: _vm.eventProxies.maxConnections
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }